'use client'

import text from '@fukku/styles/texts.module.scss'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import replacePlaceholders from 'labels/lib/replacePlaceholders'
import type { ProductColor } from 'product/types'
import { useProductCardStock } from 'product-card/hooks/useProductCardStock'
import { useShouldRenderMoreInfoLabel } from 'product-card/hooks/useShouldRenderMoreInfoLabel'
import styles from './MoreInfoLabel.module.scss'

interface MoreInfoLabelProps {
	readonly productColors: ProductColor[]
	readonly showAsFeatured: boolean
}

const COLOR_SIZE_DIVIDER = ' - '

export const MoreInfoLabel = ({
	productColors,
	showAsFeatured,
}: MoreInfoLabelProps) => {
	const { t } = useLabels()

	const { hasProductRelatedModelSizes, totalProductSizes } =
		useProductCardStock({
			productColors,
		})

	const haveColors = productColors?.length > 1

	const {
		shouldRenderMoreInfoLabel,
		shouldRenderColorAmountLabel,
		shouldRenderColorSizesDivider,
	} = useShouldRenderMoreInfoLabel({
		showAsFeatured,
		haveColors,
		hasProductRelatedModelSizes,
	})

	const placeholderColorValue = { 1: productColors?.length.toString() }

	const colorsLabel = replacePlaceholders(
		t('plp.home.colors.text.withVariable'),
		placeholderColorValue
	)

	const relatedSizes = totalProductSizes
		? { 1: totalProductSizes.toString() }
		: undefined

	const relatedProductSizesLabel = replacePlaceholders(
		t('plp.home.sizes.text.withVariable'),
		relatedSizes
	)

	if (shouldRenderMoreInfoLabel) {
		return (
			<p
				className={`${text.bodyS} ${styles.label}`}
				data-testid='productCard.moreInfoLabel'
			>
				{shouldRenderColorAmountLabel && colorsLabel}
				{shouldRenderColorSizesDivider && COLOR_SIZE_DIVIDER}
				{hasProductRelatedModelSizes && relatedProductSizesLabel}
			</p>
		)
	}

	return null
}
